
<template>
  <transition name="fade">
    <div
      v-show="showSlider === true"
      class="modal is-active"
    >
      <div class="modal-background" />
      <div class="modal-card">
        <header class="modal-card-head">
          <div class="modal-card-title has-text-centered">
            <button
              v-if="showNewWindow"
              class="button is-primary is-broad is-uppercase"
              @click="openNewWindow"
            >
              Open in New Window
            </button>
          </div>
          <button
            v-if="closeButton"
            class="delete is-default float-right close-x"
            aria-label="close"
            @click="$emit('close')"
          />
        </header>
        <section class="modal-card-body">
          <div
            style="z-index:102;width:95%;"
            class="modal-custom-body"
          >
            <vue-slick-carousel
              ref="slick"
              v-bind="slickOptions"
            >
              <div
                v-for="item in imageList"
                :key="item.id"
              >
                <div
                  class="image-container"
                  :style="{'backgroundImage': 'url(' +item.src + ')'}"
                />
                <div
                  class="is-size-5 text-container"
                  v-html="item.text"
                />
              </div>
            </vue-slick-carousel>
          </div>
        </section>
        <footer class="modal-card-foot" />
      </div>
    </div>
  </transition>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'CarouselModal',
  components: {
    VueSlickCarousel
  },
  props: {
    showSlider: {
      type: Boolean,
      default: false
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    showNewWindow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      openDelay: false,
      slickOptions: {
        dots: true,
        autoplay: false,
        infinite: false,
        accessibility: true,
        adaptiveHeight: false,
        arrows: true,
        draggable: true,
        edgeFriction: 0.3,
        swipe: true,
        center: true,
        dontAnimate: true,
        fade: true
      },
      imageList: [
        {
          id: 0,
          src: require('../../assets/store_slider/Slide0.png'),
          text:
            'Thanks for activating your Online Store – this option is now available in your Website Builder. <br><br><strong>Click the right hand arrow to view a quick walkthrough</strong>'
        },
        {
          id: 1,
          src: require('../../assets/store_slider/Slide1.png'),
          text:
            'If this is the first time you have visited the Editor, you will see a Get Started Guide. Select the site you wish to add the store to and click edit. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 2,
          src: require('../../assets/store_slider/Slide2.png'),
          text:
            'You’ll now see the Store icon on the left of the screen. Click the store icon. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 3,
          src: require('../../assets/store_slider/Slide3.png'),
          text:
            'We need to connect the store with your website – click get started. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 4,
          src: require('../../assets/store_slider/Slide4.png'),
          text:
            'Great your store is now set up with some sample products. You can easily edit or delete these in the products section. Hit store on the left to enter the online store dashboard. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 5,
          src: require('../../assets/store_slider/Slide5.png'),
          text:
            'Welcome to the shop dashboard. From here you can manage and configure your store, and track sales once the store is live. Lets look at how to add your products or services -click Add your products or services now. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 6,
          src: require('../../assets/store_slider/Slide6.png'),
          text:
            'Here you can edit or delete the sample products to create your catalogue. Assign categories, images, prices and stock levels. You can even import a stock list. When you’re ready click dashboard to move on.<br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 7,
          src: require('../../assets/store_slider/Slide7.png'),
          text:
            'You can click the tick to mark the section as done. Now let’s look at the regional settings. Click Review regional settings. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 8,
          src: require('../../assets/store_slider/Slide8.png'),
          text:
            'Here you can update your store profile, change the regional settings, setup more of the online store including checkout and link analytics. Work your way through the sections to personalise your online store. Then hit dashboard to move on.<br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 9,
          src: require('../../assets/store_slider/Slide9.png'),
          text:
            'You can click the tick to mark the section as done. Now let’s look at getting the sales delivered. Click Choose how to deliver your goods. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 10,
          src: require('../../assets/store_slider/Slide10.png'),
          text:
            'In this section you can select which shipping methods to use, whether to offer collection, local delivery or shipping (or all of these). Hit the add buttons and get your delivery options set up. Once done hit the dashboard to move on. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 11,
          src: require('../../assets/store_slider/Slide11.png'),
          text:
            'You can click the tick to mark the section as done. Now let’s make sure that you get paid. Hit Set up payment options. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 12,
          src: require('../../assets/store_slider/Slide12.png'),
          text:
            'Here you can simply connect your preferred payment option to your site or create alternative payment methods. Have a look through and don’t forget to enable them once connected. Hit dashboard to move on. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 13,
          src: require('../../assets/store_slider/Slide13.png'),
          text:
            'If you’ve been marking the sections as done, you’ll see it’s now all done. You will have seen other options that we haven’t highlighted along the way, and the options on the left hand side of the dashboard screen. Hit dashboard again. <br><br><strong>Click the right hand arrow to move to the next instruction</strong>'
        },
        {
          id: 14,
          src: require('../../assets/store_slider/Slide14.png'),
          text:
            'You’ll notice the get started list is further down the page (as you marked it as complete) and now there are other useful to-do’s for you to follow. Have a good look around and set your online store up exactly as you want it. Happy selling!'
        }
      ]
    }
  },
  watch: {
    showSlider: {
      handler (newVal, oldVal) {
        this.$refs.slick.goTo(0)
      }
    }
  },
  methods: {
    openNewWindow () {
      const routeData = this.$router.resolve({ name: 'ecommTourNewWindow' })
      window.open(routeData.href, '_blank')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/_variables.scss";
// for transition fade
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.modal-card-head {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 5px;
}

.modal-card {
  position: relative;
  transition: top 0.3s;
  top: 0;
}

.modal-card {
  width: 90%;
}

.modal-wrapper {
  z-index: 40;
}

.modal {
  z-index: 300;
}

.modal-background {
  opacity: 0.6;
}

.modal-card-head,
.modal-card-foot,
.modal-card-body {
  background-color: white;
  border: none;
}

.modal-card-body {
  color: var(--primary-color);
  font-weight: 600;
  text-align: center;
  display: flex;
  justify-content: center;
  padding-top: 0;
  overflow-x: hidden;
  overflow-y: hidden;
}

.modal-card-foot {
  justify-content: flex-end;

  @media screen and (max-width: 400px), print {
    .button {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}

.image-container {
  width: 100%;
  height: 200px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.text-container {
  margin-top: 10px;
  height: 250px;
  width: 100%;
  margin-bottom: 4px;
}

@media only screen and (min-width: 600px) {
  .text-container {
    height: 98px;
  }

  .image-container {
    width: 93%;
    height: 380px;
    margin: auto;
  }

  .modal-card-foot {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}

@media only screen and (max-height: 400px) {
  .image-container {
    width: 93%;
    height: 170px;
  }
}
@media only screen and (min-width: 991px) {
  .modal-card {
    width: 800px;
  }

  .text-container {
    height: 63px;
  }

  .image-container {
    width: 97%;
    height: 380px;
    margin: auto;
  }

  .text-container {
    height: 40%;
  }

  .modal-card-foot {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .close-x {
    margin-bottom: 11px;
  }
}
</style>
<style lang="scss">
.slick-next::before,
.slick-prev::before {
  color: var(--primary-color) !important;
}

.slick-dots li button::before {
  width: 7px;
  height: 7px;
  display: block;
  margin: 5px 5px;
  border: 1px solid var(--primary-color);
  border-radius: 30px;
  opacity: 1;
  color: transparent;
  content: "";
}

.slick-dots li.slick-active button::before {
  background-color: var(--primary-color);
  color: var(--primary-color);
  border-radius: 30px;
  opacity: 1;
  color: transparent;
  content: "";
}
</style>
